




























































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from 'vue-property-decorator';


//@ts-ignore
import poa_clasif_programaticas from '@/mixins/axios/poa_clasif_programaticas'
//@ts-ignore
import TablePPoa from '@/components/tables/tablev1'
//@ts-ignore
import PmdHeader from '@/components/headersSelect/pmd'


//@ts-ignore
import { email, required } from 'vuelidate/lib/validators';
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'


@Component({
  components: {
   /*
    Vuetable,
    VuetablePagination,*/
    
    TablePPoa
  },
  data() {
    return {
        //idmunicipio,nombre, fecha_alta, 
            // tipo, total_empleados, nombre_titular, correo, abreviacion,
  
        columnasd:[
           
            {
                tag:'tipo_gasto',
                data:'tipo_gasto',
                active:true
            },
          /* {
                tag:'delete',
                data:'delete',
                active:false
            },
            {
                tag:'edit',
                data:'edit',
                active:false
            },*/
        ],




        id:null as any,
     tipo_gasto:'' as any,
     
         
         
              poa_clasif_programaticasdata:[] as any,
      
    }
  },
     mixins: [poa_clasif_programaticas],
     validations: {
    
           tipo_gasto: {
      required,
    },
   
  },
  methods:{
       
      async eliminar(row){
         
this.$root.$emit('loading', true);
let data= await this.ELIMINAR_POA_CLASIF_PROGRAMATICA(row).then(response => {

                    if (response != null) {

 this.poa_clasif_programaticasdata=this.poa_clasif_programaticasdata.filter(item => item.id !== row.id);
 
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar eliminar paquete, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                });
      },
  /*     select(row){

//alert('pmd seleccionado');
 //this.$store.state.pmd_sel=row;
 this.$store.commit('SETPMD',row);
           //this.secretaria_sel=row;
//this.departamentos=true;
 //this.$store.commit('SETSECRETARIA',row);
   this.$router.push('/mun/general/pmd/ejes')
//this.getDataDepartamentos();

      
     },*/
     confirm(row){

let th=this;
Notiflix.Confirm.Show('Alerta de confirmacion','Desea eliminar este elemento?','Aceptar','Cancelar',function(){ 
    
    th.eliminar(row);
    },function(){ 
      
        
    });



      
     },
      limpiar(){
this.id=null;
 
     
         
 this.tipo_gasto=null;
        
    
           
      },
      addRow(){
          this.limpiar();
 $('#ac_gastos').modal('show')
      },
seteditar(row){

 this.id=row.id;
this.tipo_gasto=row.tipo_gasto;
            
          
 $('#ac_gastos').modal('show')
    

},
     async crear(dat){
let data= await this.CREAR_POA_CLASIF_PROGRAMATICA(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)

  this.poa_clasif_programaticasdata.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar editar Tipo de Gastos, refresque la pagina");

                    }    $("#ac_gastoss").modal("hide");
 this.$root.$emit('loading', false);
                    //loading.close();
                });

      },
     async editar(dat){


let data= await this.EDITAR_POA_CLASIF_PROGRAMATICA(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)
 this.$root.$emit("success", "Indicador de desempeño enlaces modificado exitosamente, refresque la pagina");
  this.poa_clasif_programaticasdata=this.poa_clasif_programaticasdata.filter(item => item.id !== dat.id);
 this.poa_clasif_programaticasdata.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar crear pmd, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                    //loading.close();
                });


      }
     ,
     async GuardarData(){



console.log('id:'+this.id)

let dat={
  id:this.id,
 
         
           tipo_gasto:this.tipo_gasto,
            idmunicipio:this.$store.state.user.usuario.id_municipio,

}
console.log(dat)
 this.$root.$emit('loading', true);
 if(this.id==null){
     this.crear(dat);
 }else{
       this.editar(dat);
 }

      },
async getData() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio
};

let data= await this.GET_POA_CLASIF_PROGRAMATICA(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.poa_clasif_programaticasdata=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},



  },
  mounted(){
      this.getData();
      //alert('10')
  }
})
export default class Home extends Vue {}

